import type { EventName } from "@lit/react";
import { ComboBox as ComboBoxElement, type ComboBoxEventMap as _ComboBoxEventMap, } from "@vaadin/combo-box/vaadin-combo-box.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { ComboBoxElement, };
export type ComboBoxEventMap<T1> = Readonly<{
    onChange: EventName<_ComboBoxEventMap<T1>["change"]>;
    onCustomValueSet: EventName<_ComboBoxEventMap<T1>["custom-value-set"]>;
    onFilterChanged: EventName<_ComboBoxEventMap<T1>["filter-changed"]>;
    onInput: EventName<_ComboBoxEventMap<T1>["input"]>;
    onInvalidChanged: EventName<_ComboBoxEventMap<T1>["invalid-changed"]>;
    onOpenedChanged: EventName<_ComboBoxEventMap<T1>["opened-changed"]>;
    onSelectedItemChanged: EventName<_ComboBoxEventMap<T1>["selected-item-changed"]>;
    onValidated: EventName<_ComboBoxEventMap<T1>["validated"]>;
    onValueChanged: EventName<_ComboBoxEventMap<T1>["value-changed"]>;
}>;
const events = { onChange: "change", onCustomValueSet: "custom-value-set", onFilterChanged: "filter-changed", onInput: "input", onInvalidChanged: "invalid-changed", onOpenedChanged: "opened-changed", onSelectedItemChanged: "selected-item-changed", onValidated: "validated", onValueChanged: "value-changed" } as ComboBoxEventMap<any>;
export type ComboBoxProps<T1> = WebComponentProps<ComboBoxElement<T1>, ComboBoxEventMap<T1>>;
export const ComboBox = createComponent({
    elementClass: ComboBoxElement, events, react: React, tagName: "vaadin-combo-box"
}) as <T1>(props: ComboBoxProps<T1> & React.RefAttributes<ComboBoxElement<T1>>) => React.ReactElement | null;
